export default __webpack_public_path__ + "static/media/dancing.fd651f07.jpg";